import { useEffect, useRef, useState } from "react"
import { Flex, Badge, Image } from "@chakra-ui/react"

interface FeedSummary {
  id: string
  feed_name: string
  feed_url: string
}

interface FeedBadgesProps {
  feeds: FeedSummary[]
}

const FeedBadges = ({ feeds }: FeedBadgesProps) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [visibleCount, setVisibleCount] = useState(feeds.length)

  const checkVisibility = () => {
    const container = containerRef.current
    if (!container) return

    const children = Array.from(container.children)
    let totalWidth = 0
    let count = 0

    for (const child of children) {
      const el = child as HTMLElement
      const elWidth = el.offsetWidth + 8 // margin 고려
      if (totalWidth + elWidth < container.offsetWidth) {
        totalWidth += elWidth
        count++
      } else {
        break
      }
    }

    setVisibleCount(count)
  }

  // ResizeObserver 적용
  useEffect(() => {
    const observer = new ResizeObserver(() => {
      checkVisibility()
    })

    if (containerRef.current) {
      observer.observe(containerRef.current)
    }

    return () => {
      observer.disconnect()
    }
  }, [])

  // feeds 변경될 때마다 한 번 체크
  useEffect(() => {
    checkVisibility()
  }, [feeds])

  // 이미지 로딩 후 다시 체크
  const handleImageLoad = () => {
    checkVisibility()
  }

  const visibleFeeds = feeds.slice(0, visibleCount)
  const hiddenCount = feeds.length - visibleCount

  return (
    <Flex
      ref={containerRef}
      gap={2}
      mt={3}
      maxH="1.5rem"
      overflow="hidden"
      whiteSpace="nowrap"
      w="90%"
    >
      {visibleFeeds.map((feed) => (
        <Badge
          key={feed.id}
          px={2}
          py={1}
          borderRadius="full"
          display="flex"
          alignItems="center"
          gap={1}
          maxW="100%"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
          overflow="hidden"
          flexShrink={0}
        >
          <Image
            src={`https://www.google.com/s2/favicons?domain_url=${feed.feed_url}&sz=64`}
            boxSize="12px"
            borderRadius="md"
            alt="favicon"
            onLoad={handleImageLoad} // ✅ 이미지 로딩 후 호출
          />
          {feed.feed_name}
        </Badge>
      ))}

      {hiddenCount > 0 && (
        <Badge
          px={2}
          py={1}
          borderRadius="full"
          bg="gray.200"
          color="gray.600"
          flexShrink={0}
        >
          +{hiddenCount}
        </Badge>
      )}
    </Flex>
  )
}

export default FeedBadges
